import { combineReducers } from 'redux';

import conversations from './conversation';
import document from './document';
import home from './home';
import language from './language';
import model from './model';
import synchronization from './synchronization';
import task from './task';
import translation from './translation';
import upload from './upload';
import userManage from './userManage';
import { RESET_STORE } from '../actionTypes';

const reducer = combineReducers({
  userManage,
  home,
  upload,
  conversations,
  task,
  translation,
  document,
  language,
  synchronization,
  model,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_STORE) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

export default rootReducer;
